
/**
 * Referenced (native) events defined here. (Minimizes bundle size.)
 */
export enum DOMEvents {
    click = 'click',
    domContentLoaded = 'DOMContentLoaded',
    load = 'load',
    message = 'message',
    scroll = 'scroll'
}

/**
 * DOM related helper functions.
 */
export const DOMUtils = {
    /**
     * Referenced attributes defined here. (Minimizes bundle size.)
     */
    attrs: {
        hidden: 'hidden',
        src: 'src',
        style: 'style'
    },

    /**
     * Promise for awaiting DOM.
     */
    ready: new Promise<void>((resolve) =>
        document.readyState === 'loading'
            ? document.addEventListener(DOMEvents.domContentLoaded, () => resolve())
            : resolve()),

    /**
     * Referenced tags defined here. (Minimizes bundle size.)
     */
    tagNames: {
        iFrame: 'iframe',
        script: 'script'
    },

    setVis(nodes: Element | Element[] | NodeList, show = true) {
        [...nodes].forEach((el: Element) => {
            const style = (el.getAttribute(DOMUtils.attrs.style) || '').replace(/;?display:[^;]+/, '')
            el.setAttribute(DOMUtils.attrs.style, `${style}${show ? '' : ';display:none'}`)
            if (show) {
                el.removeAttribute(DOMUtils.attrs.hidden)
            } else {
                el.setAttribute(DOMUtils.attrs.hidden, '')
            }
        })
    },

    /**
     * Loads javascript (https). To be used by vendor adapters only.
     *
     * @param src
     */
    loadScript(src: string): Element {
        const el = document.createElement(DOMUtils.tagNames.script)
        el.setAttribute(DOMUtils.attrs.src, src.replace(/^(?:https?:)?(.+)$/, 'https:$1'))
        document.head.appendChild(el)
        return el
    }
}
